import { createContext, useContext } from 'react';
import { Link, type LinkProps } from 'react-router';

export const NodeModalContext = createContext({ isNodeOpen: false, openEdge: (_id: string) => {}, openEdgeLabel: (_id: string) => {}, openNewNode: (_typeIds?: string[]) => {}, openNode: (_id: string) => {} });
export const useNodeModal = () => useContext(NodeModalContext);

/** Preserve real URLs, modifier-clicks, and opening links in a new tab. */
export function NodeLink({ onClick, ...props }: LinkProps) {
  const { openNode } = useNodeModal();
  return <Link {...props} onClick={event => {
    onClick?.(event);
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || props.target === '_blank') return;
    const path = typeof props.to === 'string' ? props.to : props.to.pathname;
    const id = path?.match(/^\/graph\/node\/([^/?#]+)$/)?.[1];
    if (!id || id === 'new') return;
    event.preventDefault();
    openNode(id);
  }} />;
}

/** Edge definitions and concrete edges keep their full-page URLs. */
export function EdgeLink(props: LinkProps) { return <GraphEdgeLink {...props} kind="edge" />; }
export function EdgeLabelLink(props: LinkProps) { return <GraphEdgeLink {...props} kind="label" />; }
function GraphEdgeLink({ kind, onClick, ...props }: LinkProps & { kind: 'edge' | 'label' }) {
  const { openEdge, openEdgeLabel } = useNodeModal();
  return <Link {...props} onClick={event => {
    onClick?.(event);
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || props.target === '_blank') return;
    const path = typeof props.to === 'string' ? props.to : props.to.pathname;
    const id = path?.match(/^\/graph\/(?:edge|label)\/([^/?#]+)$/)?.[1];
    if (!id || id === 'new') return;
    event.preventDefault();
    (kind === 'edge' ? openEdge : openEdgeLabel)(id);
  }} />;
}
